import styled from 'styled-components';
import { Link } from 'react-router-dom';
export const StyledWrapper = styled(Link).withConfig({ displayName: "StyledWrapper", componentId: "-8cruy" }) `
  background-color: ${(props) => props.theme.colors.white};
  padding: ${(props) => props.theme.spacers.xxl};
  border-radius: ${(props) => props.theme.borderRadius.primary};
  border: 1px solid ${(props) => props.theme.colors.silverPearl};
  height: ${(props) => (props.$fullHeight ? '100%' : 'auto')};
  display: flex;
  flex-direction: column;
  flex: 1;
  text-decoration: none;
  color: ${(props) => props.theme.body.textColor};

  &:hover {
    border-color: ${(props) => props.theme.colors.littleBoyBlue};
  }
`;
export const StyledCardLink = styled.span.withConfig({ displayName: "StyledCardLink", componentId: "-bizfr0" }) `
  margin: 0;
  font-size: 14px;
  color: ${(props) => props.theme.colors.celticBlue};

  &:hover {
    text-decoration: underline;
  }
`;
